import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { fadeUp, stagger } from "@/data/landingData";
import { usePricing } from "@/lib/pricing";

export default function Pricing() {
  const { items } = usePricing();
  return (
    <section
      id="cennik"
      className="py-24 lg:py-32 section-surface tech-grid"
      data-testid="pricing"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={stagger}
          className="text-center mb-16"
        >
          <motion.span
            variants={fadeUp}
            className="mono text-xs text-[#00E5FF] uppercase tracking-[0.2em]"
          >
            Cenník 2026
          </motion.span>
          <motion.h2
            variants={fadeUp}
            className="text-4xl sm:text-5xl font-black tracking-tight mt-4"
          >
            Transparentné <span className="text-[#00E5FF]">ceny</span>
          </motion.h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((item, i) => (
            <motion.div
              key={item.slug}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className={`relative ${item.featured ? "lg:scale-105 z-10" : ""}`}
              data-testid={`pricing-${item.slug}`}
            >
              <div
                className={`h-full glass-card p-6 ${
                  item.featured ? "trace-border glow-border-cyan" : ""
                }`}
              >
                <h3 className="text-xl font-bold mb-4">{item.title}</h3>
                <div className="flex items-baseline gap-1 mb-6">
                  <span className="mono text-sm text-zinc-500">od</span>
                  <span className="text-4xl font-black text-[#00E5FF]">
                    {Number.isInteger(item.rate) ? item.rate : Number(item.rate).toFixed(2)}
                  </span>
                  <span className="text-zinc-500">{item.unit}</span>
                </div>

                <ul className="space-y-3 mb-6">
                  {item.features.map((f, j) => (
                    <li
                      key={j}
                      className="flex items-center gap-3 text-sm text-zinc-400"
                    >
                      <CheckCircle2 size={16} className="text-[#00E5FF]" />
                      {f}
                    </li>
                  ))}
                </ul>

                <a
                  href="#kontakt"
                  className={`block text-center py-3 rounded-full font-semibold transition-all ${
                    item.featured
                      ? "bg-[#00E5FF] text-black hover:bg-[#33EEFF]"
                      : "bg-white/10 text-white hover:bg-white/20"
                  }`}
                >
                  Získať ponuku
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
